module.exports = __webpack_public_path__ + "img/nentwichVerlag_logos_color.3bb50cb4.svg";